<template>
  <button
    :id="action.value"
    :ref="action.value"
    class="action-key"
    :aria-describedby="action.value"
    :data-entity="`producer-editor-${action.value}`"
    :data-test="`panel-editor-${action.hotkey.toLowerCase()}`"
    @click="handleClickAction($event, action)"
  >
    <div class="action-key-header" style="display:flex; flex-direction: column;" :id="action.value">
      <strong class="action-key-letter">{{action.hotkey}}</strong>
      <strong class="action-key-name">{{action.display}}</strong>
    </div>

    <transition-group>
      <span
        v-for="(val, i) in filteredRipples"
        :key="'ripple' + i"
        class="ripple"
        :ref="'ripple-' + i"
        :style="{'top': val.y + 'px', 'left': val.x + 'px'}"
        @animationend="rippleEnd(i)"
      />
    </transition-group>
  </button>
</template>

<script>
export default {
  props: ['action', 'production_context'],

  mixins: [],

  inject: {
    onWidgetAction: {
      default: () => () => {},
    },
  },

  data() {
    return {
      ripples: [],
    };
  },

  mounted() {
    window.addEventListener('keypress', this.handleKeyPress);
  },

  unmounted() {
    window.removeEventListener('keypress', this.handleKeyPress);
  },

  computed: {
    filteredRipples() {
      return this.ripples.filter((r) => r.show);
    },
  },

  methods: {
    rippleEnd(i) {
      this.ripples[i].show = false;
    },

    handleClickAction(e, action) {
      const el = this.$refs[action.value];
      if (!el) {
        console.warn('Ignoring handleClickAction for button that no longer exists:', action.value, this.$refs);
        return;
      }

      const pos = el.getBoundingClientRect();

      this.ripples.push({
        x: e.clientX - pos.left,
        y: e.clientY - pos.top,
        show: true,
      });

      switch (action.type) {
        case 'frame-trigger': {
          this.$emit('trigger', action.value);
          break;
        }

        case 'timer widget': {
          this.onWidgetAction(action);
          break;
        }

        default: {
          if (this.production_context.live) {
            this.$store.dispatch('sendAction', action);
          }

          if (this.production_context.preview) {
            this.$store.dispatch('sendPreviewAction', action);
          }
        }
      }
    },

    handleKeyPress(e) {
      const self = this;
      if (
        self.action.hotkey.toLowerCase() === e.key.toLowerCase()
        && e.target.tagName !== 'INPUT'
      ) {
        self.handleClickAction(e, self.action);
      }
    },
  },
};
</script>
